import { tv } from 'tailwind-variants'

import { body1, caption, h3, h5 } from '@ui-kit/core/typography'

export const circularProgress = tv({
  slots: {
    container: 'inline-flex aspect-square shrink-0 items-center justify-center',
    center: 'absolute grid place-items-center',
    text: '',
    textWrapper: 'absolute items-center justify-center',
    icon: 'pointer-events-none absolute',
  },
  variants: {
    size: {
      small: {
        text: h5({ align: 'center', className: 'text-brand-dark' }),
        container: 'h-[56px] w-[56px]',
      },
      large: {
        text: h3({ align: 'center', className: 'text-brand-dark' }),
        container: 'h-[76px] w-[76px]',
      },
    },
    webOptimized: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      size: 'small',
      webOptimized: true,
      class: {
        text: caption({ bold: true, align: 'center', className: 'text-brand-dark' }),
      },
    },
    {
      size: 'large',
      webOptimized: true,
      class: {
        text: body1({
          bold: true,
          align: 'center',
          emphasis: 'medium',
          className: 'text-brand-dark',
        }),
      },
    },
  ],
  defaultVariants: {
    size: 'small',
    webOptimized: false,
  },
})
